import React, { useState } from 'react';
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhone,
  FaPlus,
  FaSearch,
  // eslint-disable-next-line prettier/prettier
  FaTwitter
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import mainLogo from '../../assets/images/logo-white.svg';
import MobileMenu from '../MobileMenu';

function Header() {
  const [showSearch, setShowSearch] = useState(true);
  const searchHanlder = () => {
    setShowSearch(!showSearch);
  };

  return (
    <header className="header-wrapper">
      <nav className="navbar">
        <div className="navbar-content d-flex">
          <div className="logo-wrapper">
            <Link to="/">
              <img src={mainLogo} alt="Credom" />
            </Link>
          </div>
          <div className="menu-wrapper d-flex flex-column">
            <div className="top-menu d-flex justify-content-between align-items-center">
              <div className="top-menu-left">
                <ul className="contact-info d-flex">
                  <li className="contact-item">
                    <span className="item-icon">
                      <FaPhone />
                    </span>
                    <span className="item-text">+1 302 246 1000</span>
                  </li>
                  <li className="contact-item">
                    <span className="item-icon">
                      <FaEnvelope />
                    </span>
                    <span className="item-text">architecture@example.com</span>
                  </li>
                  <li className="contact-item">
                    <span className="item-icon">
                      <FaMapMarkerAlt />
                    </span>
                    <span className="item-text">
                      805 Third Avenue, 7th Floor, NY 10022
                    </span>
                  </li>
                </ul>
              </div>
              <div className="top-menu-right">
                <div className="social-icons">
                  <a href="/" className="social-link">
                    <span className="social-icon">
                      <FaInstagram />
                    </span>
                  </a>
                  <a href="/" className="social-link">
                    <span className="social-icon">
                      <FaTwitter />
                    </span>
                  </a>
                  <a href="/" className="social-link">
                    <span className="social-icon">
                      <i className="fab fa-facebook-f" />
                      <FaFacebookF />
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div className="main-menu d-flex align-items-center justify-content-between">
              <div className="main-menu-left d-flex align-items-center">
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About</Link>
                  </li>
                  <li>
                    <Link to="/services">
                      Services
                      <span className="icon">
                        <FaPlus />
                      </span>
                    </Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="/services">Services</Link>
                      </li>
                      <li>
                        <Link to="/services-details">Service Details</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/portfolio">
                      Portfolio
                      <span className="icon">
                        <FaPlus />
                      </span>
                    </Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="/portfolio">Portfolio</Link>
                      </li>
                      <li>
                        <Link to="/portfolio-details">Portfolio Details</Link>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <Link to="/blog">
                      Blog
                      <span className="icon">
                        <FaPlus />
                      </span>
                    </Link>
                    <ul className="sub-menu">
                      <li>
                        <Link to="/blog">Blog Grid</Link>
                      </li>
                      <li>
                        <Link to="/single-blog">Single post</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </div>
              <div className="main-menu-right d-flex align-items-center">
                <span className="menu-right-search">
                  <FaSearch onClick={searchHanlder} />
                </span>
                <div className={showSearch ? 'search-box' : 'search-box show'}>
                  <div className="search-input-wrapper d-flex">
                    <input type="text" placeholder="Search here..." />
                    <button type="button" className="search-button">
                      <FaSearch />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <MobileMenu />
    </header>
  );
}

export default Header;
